export const name = "SUBSTRING";
export const summary = `Alias for \`SUBSTR\``;
export const reference = `
## SUBSTRING

Alias for \`SUBSTR\`

\`\`\`
SUBSTRING(value, position[, length])
\`\`\`

### Alias for SUBSTR.




source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
